/*****************************************

jQuery.CaracolWordpressJsonp
version 4.0
Hiroshi Fukuda <dada@sygnas.jp>
http://sygnas.jp/

WordPress用 Jsonp吐き出しプラグイン「Export File Jsonp」の吐き出すJsonpを読み込んで表示する
*/

/*
{%ID%}		記事ID
{%NUM%}		記事番号 0～
{%TYPE%}	post / カスタムタイプ
{%POSTDAY%}	投稿日
{%POSTDAY_Y%}	投稿日　年
{%POSTDAY_M%}	投稿日 月
{%POSTDAY_D%}	投稿日 日
{%POSTTIME%}	投稿日 年
{%POSTTIME_H%}	投稿時刻　時
{%POSTTIME_M%}	投稿時刻　分
{%POSTTIME_S%}	投稿時刻　秒
{%TITLE%}	題名
{%LINK%}	記事URL
{%THUMB_SRC%}	サムネイル　URL
{%THUMB_WIDTH%}	サムネイル　幅
{%THUMB_HEIGHT%}	サムネイル　高さ
{%CATEGORY_NAME%}	記事カテゴリ
{%CATEGORY_SLUG%}	記事カテゴリスラッグ
{%CATEGORY_NAME_ALL%}	記事カテゴリ　全部
{%CATEGORY_SLUG_ALL%}	記事カテゴリスラッグ　全部
{%TERM_SLUG%}	タクソノミースラッグ
{%TERM_SLUG_ALL%}	タクソノミースラッグ　全部
{%CONTENT%}	本文
{%CUSTOM_任意文字%}	カスタムフィールド

2016.11.22 ver4.1
・$.ajax.done(); 方式に変更

2016.05.09 ver4.0
・Webpack用に刷新

2015.12.17 ver3.0
・画像処理とか外して作り直し。フォーマット置換文字列も変更

2013.11.04 ver2.0
・修正点不明

2013.09.17 ver1.9
・Wordpress標準のアイキャッチ画像を使うように変更

2013.09.17 ver1.8
・{%DAY_Y%}、{%DAY_M%}、{%DAY_D%}　を追加

2013.06.30 ver1.7
・{%CATEGORY%}と{%TERM%}を統合した{%TOTALCATEGORY%}を追加

2013.05.18 ver1.6
・画像読み込み方法を修正

-------------
usage
-------------
var CaracolWordpressJsonp = require('./caracol/wordpress/jquery.wpjsonp.js');
wpjsonp = new CaracolWordpressJsonp({
    format: '<dt>{%POSTDAY%}</dt><dd><a href="{%LINK%}">{%TITLE%}</a></dd>',
    onComplete: function( data ){
        $('.js-news').html(data);
    }
});
wpjsonp.load('http://shingeki.tv/news/output/export_new_jsonp.php');


*/

var CaracolWordpressJsonp;

module.exports = CaracolWordpressJsonp = function( config ){
	'use strict';
	var defaults = {
		format: '<li><a href="{%LINK%}">{%TITLE%}</a></li>',
		onComplete: function(){}
	};

	this.outputArray = [];
	this.opt = jQuery.extend( defaults, config );
};


/***************************************
* 読み込み開始
*/
CaracolWordpressJsonp.prototype.load = function ( jsonpSrc ){
	'use strict';

	var self = this;

	// 読み込み開始
	$.ajax({
		url : jsonpSrc,
		type : 'GET',
		dataType : 'jsonp',
		context: this
	}).done( self.load_complete );
}

/***************************************
* 読み込み完了
*/
CaracolWordpressJsonp.prototype.load_complete = function ( data, textStatus, jqXHR ){
	"use strict";

	for( var i=0; i<data.length; i++ ){

		// 各アーティクル情報
		var article = data[i];
		var format = this.opt.format;

		format = format.split('{%ID%}').join( article.id );
		format = format.split('{%NUM%}').join( i );
		format = format.split('{%TYPE%}').join( article.type );

		format = format.split('{%POSTDAY%}').join( article.postday );
		format = format.split('{%POSTDAY_Y%}').join( article.postday.substr(0,4) );
		format = format.split('{%POSTDAY_M%}').join( article.postday.match(/\d+\.(\d+)\.\d+/)[1] );
		format = format.split('{%POSTDAY_D%}').join( article.postday.match(/\d+\.\d+\.(\d+)/)[1] );

		format = format.split('{%POSTTIME%}').join( article.posttime );
		format = format.split('{%POSTTIME_H%}').join( article.posttime.match(/(\d+):\d+:\d+/)[1] );
		format = format.split('{%POSTTIME_M%}').join( article.posttime.match(/\d+:(\d+):\d+/)[1] );
		format = format.split('{%POSTTIME_S%}').join( article.posttime.match(/\d+:\d+:(\d+)/)[1] );

		format = format.split('{%TITLE%}').join( article.title );
		format = format.split('{%LINK%}').join( article.link );

		if( article.thumbnail ){
			format = format.split('{%THUMB_SRC%}').join( article.thumbnail.src );
			format = format.split('{%THUMB_WIDTH%}').join( article.thumbnail.width );
			format = format.split('{%THUMB_HEIGHT%}').join( article.thumbnail.height );
		}

		format = format.split('{%CATEGORY_NAME%}').join( article.category_name[0] );
		format = format.split('{%CATEGORY_SLUG%}').join( article.category_slug[0] );
		format = format.split('{%CATEGORY_NAME_ALL%}').join( article.category_name.join(' ') );
		format = format.split('{%CATEGORY_SLUG_ALL%}').join( article.category_slug.join(' ') );

		format = format.split('{%TERM_SLUG%}').join( article.terms_slug[0] );
		format = format.split('{%TERM_SLUG_ALL%}').join( article.terms_slug.join(' ') );

		format = format.split('{%CONTENT%}').join( article.content );

		var matches = format.match(/{%CUSTOM_.+?%}/);
		if( matches ){
			for( var p=0; p<matches.length; p++ ){
				var key = matches[p].match(/{%CUSTOM_(.+?)%}/)[1];
				format = format.split( matches[p] ).join( article.custom[key] );
			}
		}

		// 出力テキスト
		this.outputArray.push( format );

	}

	// 指定された完了関数を実行
	this.opt.onComplete( this.outputArray );
};




